import {
    Box,
    FormHelperText,
    Grid,
    InputLabel,
    Typography,
} from '@mui/material';
import React from 'react';
import FormCheckbox from '../../../shared/FormCheckbox';
import FormCounter from '../../../shared/FormCounter';
import FormTextField from '../../../shared/FormTextField';
import { Control } from 'react-hook-form';
import { ExperienceType } from '../../../enums/experience';
import FormSwitch from '../../../shared/FormSwitch';

interface BoardRoomFormProps {
    control: Control<any>;
    type?: string;
}

const BoardRoomForm = ({ control, type }: BoardRoomFormProps) => {
    return (
        <>
            {type === ExperienceType.Commercial && (
                <Grid container columnSpacing={5} rowSpacing={1}>
                    <Grid item xs={12}>
                        <InputLabel htmlFor='assignedName__input' required>
                            Name
                        </InputLabel>
                        <FormTextField
                            id='assignedName__input'
                            name='assignedName'
                            control={control}
                            placeholder='Death Star'
                        />
                    </Grid>
                </Grid>
            )}
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid item container xs={12} md={6}>
                    <Grid item xs={12}>
                        <Typography
                            component='h2'
                            variant='h3'
                            color='text.primary'
                            sx={{ mb: 0.25 }}
                        >
                            Amenities
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='projector__checkbox'
                        name='projector'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='projector__checkbox'>
                        Projector
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='whiteboard__checkbox'
                        name='whiteboard'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='whiteboard__checkbox'>
                        Whiteboard
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='outletsAndChargers__checkbox'
                        name='outletsAndChargers'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='outletsAndChargers__checkbox'>
                        Outlets And Chargers
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='cableAdapters__checkbox'
                        name='cableAdapters'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='cableAdapters__checkbox'>
                        Cable Adapters
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='soundSystem__checkbox'
                        name='soundSystem'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='soundSystem__checkbox'>
                        Sound System
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='tv__checkbox'
                        name='tv'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='tv__checkbox'>TV</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='transmittingEquipment__checkbox'
                        name='transmittingEquipment'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='transmittingEquipment__checkbox'>
                        Transmitting Equipment
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='camera__checkbox'
                        name='camera'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='camera__checkbox'>Camera</InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='zoom__checkbox'
                        name='zoom'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='zoom__checkbox'>Zoom</InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='msTeams__checkbox'
                        name='msTeams'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='msTeams__checkbox'>
                        Microsoft Teams
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='googleMeet__checkbox'
                        name='googleMeet'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='googleMeet__checkbox'>
                        Google Meet
                    </InputLabel>
                </Grid>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='microphone__checkbox'
                        name='microphone'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='microphone__checkbox'>
                        Microphone
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <FormCheckbox
                        id='printingAndScanning__checkbox'
                        name='printingAndScanning'
                        control={control}
                        sx={{ p: 0 }}
                    />
                    <InputLabel htmlFor='printingAndScanning__checkbox'>
                        Printing and Scanning
                    </InputLabel>
                </Grid>
            </Grid>
            <Grid item xs={12} sx={{ pt: 2 }}>
                <Typography
                    component='h2'
                    variant='h3'
                    color='text.primary'
                    sx={{ mb: 0.25 }}
                >
                    Arrangement
                </Typography>
            </Grid>
            <Grid container columnSpacing={5} rowSpacing={1}>
                <Grid
                    item
                    container
                    xs={12}
                    md={6}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                    }}
                >
                    <InputLabel htmlFor='seatingCapacity__input'>
                        Seating Capacity
                    </InputLabel>
                    <FormCounter
                        id='seatingCapacity__input'
                        name='seatingCapacity'
                        disabled={false}
                    />
                </Grid>
            </Grid>{' '}
        </>
    );
};

export default BoardRoomForm;
